import { render, staticRenderFns } from "./AddFranchise.vue?vue&type=template&id=15a0b4ac"
import script from "./AddFranchise.vue?vue&type=script&lang=js"
export * from "./AddFranchise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports